/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */
import { apiPlugin, storyblokInit } from 'gatsby-source-storyblok';
import React, { ReactNode, memo } from 'react';
import Article from '../../Article/Article';
import ArticleCards from '../../ArticleCards/ArticleCardsBlok';
import ArticleHero from '../../ArticleHero/ArticleHero';
import ArticleIndexPage from '../../ArticleIndexPage/ArticleIndexPage';
import ArticleQuote from '../../ArticleQuote/ArticleQuote';
import CTABarLargeBlok from '../../CTABarLarge/CTABarLargeBlok';
import CTABarSmall from '../../CTABarSmall/CTABarSmall';
import CTABarSmallBlok from '../../CTABarSmall/CTABarSmallBlok';
import CategoryLandingPage from '../../CategoryLandingPage/CategoryLandingPage';
import ContactBar from '../../ContactBar/ContactBar';
import ContactPointStructuredData from '../../ContactPointStructuredData/ContactPointStructuredData';
import ContentAndMedia from '../../ContentAndMedia/ContentAndMedia';
import DowntimeBanner from '../../DowntimeBanner/DowntimeBanner';
import FeaturedArticleCard from '../../FeaturedArticleCard/FeaturedArticleCard';
import FeaturedPanel from '../../FeaturedPanels/FeaturedPanel';
import FeaturedPanels from '../../FeaturedPanels/FeaturedPanels';
import FlatArticleIndexPageResults from '../../FlatArticleIndexPageResults/FlatArticleIndexPageResults';
import Footer from '../../Footer/Footer';
// import FormFieldAddressLookup from '../../FormFields/FormFieldAddressLookup/FormFieldAddressLookup';
import DataWrapperEmbed from '../../DataWrapperEmbed/DataWrapperEmbed';
import FormFieldMultiOptionsSelect from '../../FormFields/FormFieldMultiOptionsSelect/FormFieldMultiOptionsSelect';
import FormFieldRow from '../../FormFields/FormFieldRow/FormFieldRow';
import FormFieldSingleOptionSelectButtons from '../../FormFields/FormFieldSingleOptionSelectButtons/FormFieldSingleOptionSelectButtons';
import FormFieldSingleOptionSelectDropdown from '../../FormFields/FormFieldSingleOptionSelectDropdown/FormFieldSingleOptionSelectDropdown';
import FormFieldTextInput from '../../FormFields/FormFieldTextInput/FormFieldTextInput';
import FormFieldToolTip from '../../FormFields/FormFieldToolTip/FormFieldToolTip';
import GetQuoteDropdownButton from '../../GetQuoteDropdownButton/GetQuoteDropdownButton';
import GroupedArticleIndexPageResults from '../../GroupedArticleIndexPageResults/GroupedArticleIndexPageResults';
import Header from '../../Header/Header';
import HomepageHero from '../../HomepageHero/HomepageHero';
import ListAndMedia from '../../ListAndMedia/ListAndMedia';
import LocationAddressStructuredData from '../../LocationAddressStructuredData/LocationAddressStructuredData';
import NextSteps from '../../NextSteps/NextSteps';
import NumberedList from '../../NumberedList/NumberedList';
import NumberedListAndMedia from '../../NumberedListAndMedia/NumberedListAndMedia';
import OrganisationStructuredData from '../../OrganisationStructuredData/OrganisationStructuredData';
import Page from '../../Page/Page';
import PageHeroVariantOne from '../../PageHeroVariantOne/PageHeroVariantOne';
import PageHeroVariantTwo from '../../PageHeroVariantTwo/PageHeroVariantTwo';
import PartnersBlok from '../../PartnersBlok/PartnersBlok';
import PrimaryCTA from '../../PrimaryCTA/PrimaryCTA';
import ProductStructuredData from '../../ProductStructuredData/ProductStructuredData';
import ConditionalFormSection from '../../QuoteFormSections/ConditionalFormSection/ConditionalFormSection';
import PersonalDetailsReviewAndEditFormSection from '../../QuoteFormSections/PersonalDetailsReviewAndEditFormSection/PersonalDetailsReviewAndEditFormSection';
import StaticFormSection from '../../QuoteFormSections/StaticFormSection/StaticFormSection';
import StaticFormSectionAddress from '../../QuoteFormSections/StaticFormSectionAddress/StaticFormSectionAddress';
import SubmitFormSection from '../../QuoteFormSections/SubmitFormSection/SubmitFormSection';
import QuoteConfirmationPage from '../../QuoteStagePages/QuoteConfirmation/QuoteConfirmationPage';
import QuoteCostBreakdownSection from '../../QuoteStagePages/QuoteStageBloks/QuoteCostBreakdownSection/QuoteCostBreakdownSection';
import QuoteDetails from '../../QuoteStagePages/QuoteStageBloks/QuoteDetails/QuoteDetails';
import QuoteMoveSpecialist from '../../QuoteStagePages/QuoteStageBloks/QuoteMoveSpecialist/QuoteMoveSpecialist';
import Email from '../../QuoteStagePages/QuoteStageBloks/QuoteMoveSpecialist/QuoteMoveSpecialistAvailableContactMethods/Email/Email';
import LiveChat from '../../QuoteStagePages/QuoteStageBloks/QuoteMoveSpecialist/QuoteMoveSpecialistAvailableContactMethods/LiveChat/LiveChat';
import Phone from '../../QuoteStagePages/QuoteStageBloks/QuoteMoveSpecialist/QuoteMoveSpecialistAvailableContactMethods/Phone/Phone';
import Whatsapp from '../../QuoteStagePages/QuoteStageBloks/QuoteMoveSpecialist/QuoteMoveSpecialistAvailableContactMethods/Whatsapp/Whatsapp';
import QuotePartnerSite from '../../QuoteStagePages/QuoteStageBloks/QuotePartnerSite/QuotePartnerSite';
import QuoteStageConditionalContent from '../../QuoteStagePages/QuoteStageBloks/QuoteStageConditionalContent/QuoteStageConditionalContent';
import QuoteTotalAndButtons from '../../QuoteStagePages/QuoteStageBloks/QuoteTotalAndButtons/QuoteTotalAndButtons';
import QuoteTotalTermsAndButtons from '../../QuoteStagePages/QuoteStageBloks/QuoteTotalTermsAndButtons/QuoteTotalTermsAndButtons';
import QuoteStageOnePage from '../../QuoteStagePages/QuoteStageOnePage/QuoteStageOnePage';
import QuoteStageThreePage from '../../QuoteStagePages/QuoteStageThreePage/QuoteStageThreePage';
import QuoteStageTwoPage from '../../QuoteStagePages/QuoteStageTwoPage/QuoteStageTwoPage';
import RichText from '../../RichTextContainer/RichTextContainer';
import SearchResultsPage from '../../SearchResultsPage/SearchResultsPage';
import SecondaryCTA from '../../SecondaryCTA/SecondaryCTA';
import SectionTitle from '../../SectionTitle/SectionTitleBlok';
import SharePageBar from '../../SharePageBar/SharePageBar';
import SocialsStructuredData from '../../SocialsStructuredData/SocialsStructuredData';
import Spacer from '../../Spacer/Spacer';
import Table from '../../Table/Table';
import TableHeaderRow from '../../Table/TableHeaderRow';
import TableRow from '../../Table/TableRow';
import Tables from '../../Tables/Tables';
import TertiaryCTA from '../../TertiaryCTA/TertiaryCTA';
import TooltipParagraph from '../../TooltipParagraph/TooltipParagraph';
import TrustPilot from '../../TrustPilot/TrustPilot';
import Video from '../../Video/Video';
import VideoStructuredData from '../../VideoStructuredData/VideoStructuredData';
import FallbackComponent from '../FallbackComponent/FallbackComponent';
import PageNotFoundHero from '../../PageNotFoundHero/PageNotFoundHero';
import PageHeroVariantThree from '../../PageHeroVariantThree/PageHeroVariantThree';
import PlaystoreIcons from '../../PlaystoreIcons/PlaystoreIcons';
import StaticFormCheckbox from '../../QuoteFormSections/StaticFormCheckbox/StaticFormCheckbox';
import NextStepsList from '../../NextStepsList/NextStepsList';
import BlogCard from '../../BlogCard/BlogCard';
import StampDutyCalculator from '../../StampDutyCalculator/StampDutyCalculator';
import AuthorPage from '../../AuthorPage/AuthorPage';
import AuthorHero from '../../AuthorPage/AuthorHero';
import AuthorArticles from '../../AuthorPage/AuthorArticles';
import CTAWithDropdown from '../../CTAWithDropdown/CTAWithDropdown';
import QuickQuote from '../../QuickQuote/QuickQuote';
import ServiceCTAComponent from '../../ServiceCTA/ServiceCTA.component';
import MediumCTABanner from '../../MediumCTABanner/MediumCTABanner';
import EmbeddedQuoteFormPage from '../../EmbeddedQuoteFormPage/EmbeddedQuoteFormPage';
import IframeEmbed from '../../IframeEmbed/IframeEmbed';

storyblokInit({
  accessToken: process.env.GATSBY_STORYBLOK_API_KEY,
  apiOptions: {
    cache: { type: 'memory' },
  },
  bridge: true,
  use: [apiPlugin],
  components: {
    primary_cta: PrimaryCTA,
    get_quote_dropdown_button: GetQuoteDropdownButton,
    page: Page,
    homepage: Page,
    page_not_found: Page,
    contact_us_page: Page,
    header: Header,
    footer: Footer,
    section_title: SectionTitle,
    content_and_media: ContentAndMedia,
    contact_bar: ContactBar,
    share_page_bar: SharePageBar,
    trust_pilot: TrustPilot,
    featured_panels: FeaturedPanels,
    featured_panel: FeaturedPanel,
    cta_bar_large: CTABarLargeBlok,
    cta_bar_small: CTABarSmallBlok,
    search_results_page: SearchResultsPage,
    featured_article_card: FeaturedArticleCard,
    article_cards: ArticleCards,
    list_and_media: ListAndMedia,
    numbered_list_and_media: NumberedListAndMedia,
    dynamic_numbered_list: NumberedList,
    next_steps: NextSteps,
    rich_text: RichText,
    article_cta_bar: CTABarSmall,
    youtube_video: Video,
    article_quote: ArticleQuote,
    category_landing_page: CategoryLandingPage,
    homepage_hero: HomepageHero,
    page_hero_variant_one: PageHeroVariantOne,
    page_hero_variant_two: PageHeroVariantTwo,
    page_hero_variant_three: PageHeroVariantThree,
    article: Article,
    article_hero: ArticleHero,
    article_index_page: ArticleIndexPage,
    grouped_article_index_page_results: GroupedArticleIndexPageResults,
    flat_article_index_page_results: FlatArticleIndexPageResults,
    quote_stage_one_page: QuoteStageOnePage,
    quote_stage_two_page: QuoteStageTwoPage,
    quote_stage_three_page: QuoteStageThreePage,
    quote_complete_page: QuoteConfirmationPage,
    form_field_tool_tip: FormFieldToolTip,
    static_form_section: StaticFormSection,
    static_form_section_address: StaticFormSectionAddress,
    static_form_checkbox: StaticFormCheckbox,
    conditional_form_section: ConditionalFormSection,
    submit_form_section: SubmitFormSection,
    // form_field_address_lookup: FormFieldAddressLookup,
    form_field_multi_options_select: FormFieldMultiOptionsSelect,
    form_field_row: FormFieldRow,
    form_field_single_option_select_buttons: FormFieldSingleOptionSelectButtons,
    form_field_single_option_select_dropdown:
      FormFieldSingleOptionSelectDropdown,
    form_field_text_input: FormFieldTextInput,
    quote_partner_site: QuotePartnerSite,
    quote_details: QuoteDetails,
    quote_move_specialist: QuoteMoveSpecialist,
    live_chat: LiveChat,
    whatsapp: Whatsapp,
    phone: Phone,
    email: Email,
    quote_stage_conditional_content: QuoteStageConditionalContent,
    quote_total_and_buttons: QuoteTotalAndButtons,
    quote_cost_breakdown_section: QuoteCostBreakdownSection,
    personal_details_review_and_edit_form_section:
      PersonalDetailsReviewAndEditFormSection,
    quote_total_terms_and_buttons: QuoteTotalTermsAndButtons,
    partners_blok: PartnersBlok,
    tables: Tables,
    table: Table,
    table_header_row: TableHeaderRow,
    table_row: TableRow,
    spacer: Spacer,
    cta: SecondaryCTA,
    cta_with_dropdown: CTAWithDropdown,
    secondary_cta: SecondaryCTA,
    tertiary_cta: TertiaryCTA,
    tooltip_paragraph: TooltipParagraph,
    organisation_structured_data: OrganisationStructuredData,
    video_structured_data: VideoStructuredData,
    socials_structured_data: SocialsStructuredData,
    contact_point_structured_data: ContactPointStructuredData,
    product_structured_data: ProductStructuredData,
    location_address_structured_data: LocationAddressStructuredData,
    downtime_banner: DowntimeBanner,
    page_not_found_hero: PageNotFoundHero,
    playstore_icons: PlaystoreIcons,
    next_steps_list: NextStepsList,
    blog_card: BlogCard,
    stamp_duty_calculator: StampDutyCalculator,
    author_page: AuthorPage,
    author_hero: AuthorHero,
    author_articles: AuthorArticles,
    quick_quote: QuickQuote,
    data_wrapper_embed: DataWrapperEmbed,
    service_cta: ServiceCTAComponent,
    medium_cta_banner: MediumCTABanner,
    embedded_quote_form: EmbeddedQuoteFormPage,
    iframe_embed: IframeEmbed,
  },
  enableFallbackComponent: true,
  customFallbackComponent: FallbackComponent,
});

interface StoryBlokProviderProps {
  children: ReactNode;
}

const StoryblokProvider: React.FC<StoryBlokProviderProps> = memo(
  ({ children }) => children
);

export const withStoryblokProvider = (content: ReactNode) => (
  <StoryblokProvider>{content}</StoryblokProvider>
);
